import React from 'react';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { ThemeProvider, Checkbox, Textfield, Dropdown } from '@workboard/wobo-ui';
import styled from 'styled-components';
import GoalServices from '../../../../services/goal.services';
import PermissionComp from './permission.component';
import { reactLoader, removeReactLoader, constructNestedKRPayload } from '../../../../utils/common.js';
import DeleteCommonModal from '../../../deleteCommonModal.component';
import  RetainUpdateModal  from '../../../retainUpdateModal.component';
import KrAlignDependance from './krAlignDependence';
import MetricOwnerCommonModal from './metric-owner.component';
import NestedInlineComp from './NestedInline.component';
import HelpTextComp from '../../../helper/helptext.component';
import { IntervalTexts, getIntervalOptions, getWeekDaysOptions, isWeeklyInterval } from '../../../../utils/metric';
import { ErrorTextComp } from "../../../inputs/fields.component";
import AddKrTag from "../../../../krTags/components/addkrTag.component";
import { isNumberWithComma, replaceNumericCommaValue } from '../../../../utils/function';
import {getTargetValue} from '../../../common/getTargetValue.component'
import Customokr from './../../../custom_fields/customobj/Customokr';
import KrRelationshipWrapper from './krRelationshipWrapper';
import KrMilestonesSection from './KrMilestonesSection';
import he from 'he';
import { krdetailConstants, KR_TYPES } from '../../../../constants/krdetails.constants';
import { WbEventHandlerMixins } from '../../../../utils/common';
import { AddFinancialTargetsButton } from '../AddFinancialTargetsButton';
import { isKrDurationChangedFromSaved } from '../../../../utils/krQuarterDuration';
import { KR_CAUTION, resolveKrCaution } from '../../../../utils/krCautionPrecedence';
import { isKrTimespanWithinObjective } from '../goalPeriodRows';

// ustom_fields/customobj/Customokr
const StyledCheckbox = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -5px;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

const StyledDropdown = styled(Dropdown)`
  min-width: 113px !important;
  max-width: fit-content;
  height: 39px !important;
  > svg {
    margin-right: 10px !important;
  }
  .MuiSelect-root {
    background-color: #f2f2f2 !important;
    border: 1px solid rgba(0,0,0,0.06);
    height: 38px;
  }
  .MuiSelect-select.Mui-disabled {
		.MuiListItemText-root{
			color: rgba(0, 0, 0, 0.87) !important;
		}
	}
	.MuiSelect-icon.Mui-disabled{
		display: none;
	}
  #unit-measure-dropdown{
    min-width: 177px;
  }
  #cal-overall-dropdown{
    min-width: 226px;
  }
  #select-day-dropdown{
    min-width: 120px;
  }
  #select-interval-dropdown{
    min-width: 113px;
  }
  #result-value-dropdown {
    min-width: 212px;
  }
`;

class BasicMetricModal extends React.Component {
  constructor(props) {
    super(props);
  console.log("---<>",this.props)
    let isStretchEnabled = this.props.addOkrData.isStretchEnabled ??  this.props.goalDetails.isStretchEnabled ?? false;
    let committedKRFlag = isStretchEnabled && this.props.item && parseInt(this.props.item.committed_target) ? parseInt(this.props.item.committed_target) : 0;
    const { t } = this.props
    const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
    this.state = {
      MeasureEn: false,
      isCustomSave:[],
      name: this.props.item && this.props.item.name ? this.props.item.name : "",
      initial_data:
        this.props.item && this.props.item.initial_data
          ? this.props.item.initial_data
          : this.props.basicInlineData &&
            this.props.basicInlineData.initial_data
            ? this.props.basicInlineData.initial_data
            : this.props.predicted ? this.props.krExtractInitialValue : 0,
      target:
          ((!isStretchEnabled && this.props.item && this.props.item.target) ||
          (isStretchEnabled && this.props.item && this.props.item.stretch_target && this.props.item.stretch_target.length > 0) ||
          (isStretchEnabled && committedKRFlag))
        ? this.props.item.target : !isStretchEnabled && this.props.basicInlineData && this.props.basicInlineData.target
        ? this.props.basicInlineData.target : !isStretchEnabled && this.props.predicted ? this.props.krExtractTargetValue
        : '',
      stretch:  isStretchEnabled && ((Array.isArray(this.props.basicInlineData) && this.props.basicInlineData.length > 0) || Object.keys(this.props.basicInlineData).length > 0) ?
        (this.props.basicInlineData.stretch_target !== undefined ?
          (this.props.basicInlineData.stretch_target === '' ? this.props.basicInlineData.target : this.props.basicInlineData.stretch_target) : this.props.basicInlineData.target
        )
        : isStretchEnabled && this.props.predicted ? this.props.krExtractTargetValue
        : this.props.item && this.props.item.stretch_target && this.props.item.stretch_target.length > 0
        ? this.props.item.stretch_target
        : isStretchEnabled && this.props.item && this.props.item.target && !committedKRFlag
        ? this.props.item.target
        : '',
      measure: 1,
      interval:
        this.props.item && this.props.item.interval
          ? this.props.item.interval
          : this.props.basicInlineData && this.props.basicInlineData.interval
            ? this.props.basicInlineData.interval
            : "",
      data_provider: {
        id: this.props.owner.id,
        name: this.props.owner.name,
        avatar: this.props.owner.avatar,
      },
      measureText: "Count as number",
      intervalText: "Weekly",
      ErrorDis: "",
      intervalEn: "",
      krOwnerEn: false,
      fields: {},
      errors: {},
      porgressEn: false,
      TargetHelpPopUp: false,
      dayEn: false,
      progressHelpPopUp: false,
      permissionHelpPopUp: false,
      intervalDayEn: false,
      upper_limit:
        this.props.item && this.props.item.upper_limit
          ? this.props.item.upper_limit
          : "",
      lower_limit:
        this.props.item && this.props.item.upper_limit
          ? this.props.item.lower_limit
          : "",
      range: false,
      dsMetric:
        this.props.mitChildKr && this.props.item && this.props.item.counting != null
          ? parseInt(this.props.item.counting)
          : this.props.mitChildKr && this.props.counting != null
          ? parseInt(this.props.counting)
          : (this.props.item && parseInt(this.props.item.counting))
          ? parseInt(this.props.item.counting)
          : this.props.basicInlineData && parseInt(this.props.basicInlineData.counting)
          ? parseInt(this.props.basicInlineData.counting) : this.props.predicted ? this.props.krExtractDirectionValue : 1,
      metricDD: false,
      progType:
        this.props.item && this.props.item.progress_type
          ? this.props.item.progress_type
          : this.props.mitType ? this.props.getProgressType(this.props.mitType) : 1,
      measureType:
        this.props.item && this.props.item.metric
          ? (this.props.item.metric == 4 || this.props.item.metric == 0) ? 1 : this.props.item.metric
          : this.props.basicInlineData && this.props.basicInlineData.metric
            ? this.props.basicInlineData.metric
            : this.props.predicted ? this.props.krExtractValueType : 1,
      intervalType:
        this.props.item && this.props.item.interval
          ? this.props.item.interval != 0 ? this.props.item.interval : 2
          : this.props.basicInlineData && this.props.basicInlineData.interval
            ? this.props.basicInlineData.interval != 0 ? this.props.basicInlineData.interval : 2
            : 2,
      dayType:
        this.props.item && this.props.item.weekly_update_day
          ? this.props.item.weekly_update_day
          : 5,
      teamPermissionSelected:
        this.props.item && this.props.item.permission_teams
          ? this.props.item.permission_teams
          : this.props.goalDetails.type == 1 &&
					this.props.goalDetails.default_permission_teams &&
					Object.keys(this.props.goalDetails.default_permission_teams).length > 0
					? this.props.goalDetails.default_permission_teams : [],
      bizPermissionSelected:  this.props.item && this.props.item.permission_biz ? this. props.item.permission_biz : [],
      permission: [],
      permissionstate:
        this.props.item && this.props.item.permission
          ? this.props.item.permission.split(",").map(Number)
          : this.props.goalDetails.type == 1 ? (this.props.goalDetails.default_permission &&
            Object.keys(this.props.goalDetails.default_permission).length > 0 ? this.props.goalDetails.default_permission.split(",").map(Number) : [8])  : [10],
      applyObjKr:
        this.props.goalDetails && this.props.goalDetails.all_metrics == 1
          ? true
          : false,
      source:
        this.props.item && this.props.item.source ? this.props.item.source : 1,
      Exclude:
        this.props.item && this.props.item.progress_consider == 0
          ? true
          : false,
      krId: this.props.item && this.props.item.id ? this.props.item.id : "",
      subPermissonEn: false,
      startValueErr: t("Add Value"),
      targetValueErr: t("Add Value"),
      stretchValueErr: t("Add Value"),
      lowerLimitErr: t("Add Value"),
      upperLimitErr: t("Add Value"),
      _isTeamMounted: false,
      krPermissionText:
        this.props.goalDetails &&
          this.props.goalDetails.permission &&
          this.props.goalDetails.permission.length > 0
          ? this.props.goalDetails &&
            this.props.goalDetails.permission &&
            this.props.goalDetails.permission.length > 1
            ? t("Custom view permissions")
            : t("Organization can view")
          : this.props.goalDetails.type == 1
            ? t("Only team can view")
            : t("Only owner can view"),
      _isOwnerMounted: false,
      hide: false,
      ownerSearchVal: '',
      confirmPopup: false,
      intervalConfirmPopup: false,
      krAlingSelected: this.props.item &&
        this.props.item.kr_aligns !== undefined &&
        this.props.item.kr_aligns.length > 0
        ? this.props.item.kr_aligns
        : [],
      krDependenciesSelected: this.props.item &&
        this.props.item.kr_dependent !== undefined &&
        this.props.item.kr_dependent.length > 0
        ? this.props.item.kr_dependent
        : [],
      committedKRFlag:  this.props.item && this.props.item.committed_target != null ? this.props.item.committed_target : 0,
      tags:[],
      krExtractName: this.props.predicted ? this.props.krExtractName : '',
      selectedType: '',
      titleRetain: t('Change update frequency'),
      contentRetain: '',
      sourceType:1,
      externalSource: false,
      nplTags:this.props.nplTags ? this.props.nplTags : [],
      selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
      selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
      tagsList:this.props.tagsList ? this.props.tagsList:[],
      isInitialDataChanged: false,
      isStretchEnabled: isStretchEnabled,
      isAnuualQChange:false,
      cadenceChanged: false,
      coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwners && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [])) : [],
      checkRolFlag: this.props.item?.is_real_owner_rol != undefined ? true : false,
      milestones: this.props.item?.milestones ?? [],
    };
    this.saveKr = this.saveKr.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.handleErrorChange = this.handleErrorChange.bind(this);
    this.filterTeamFunctions = this.filterTeamFunctions.bind(this);
    this.setRightPaneValue = this.setRightPaneValue.bind(this);
    this.GoalServices = new GoalServices();
    this.clickEvent = this.clickEvent.bind(this);
    this.handleExcludeChange = this.handleExcludeChange.bind(this);
    this.toggelePermission = this.toggelePermission.bind(this);
    this.toggeleSubPermission = this.toggeleSubPermission.bind(this);
    this.targetClick = this.targetClick.bind(this);
    this.permissionData = this.permissionData.bind(this);
    this.teamPermissionData = this.teamPermissionData.bind(this);
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.deleteItems = this.deleteItems.bind(this);
    this.saveItems = this.saveItems.bind(this);
    this.saveAlignArr = this.saveAlignArr.bind(this);
    this.saveDependentArr = this.saveDependentArr.bind(this);
    this.changeRadio = this.changeRadio.bind(this);
    this.updateTags = this.updateTags.bind(this);
    this.isRequiredCustomOkrFiled = this.isRequiredCustomOkrFiled.bind(this);
    this.isSaveCustom = this.isSaveCustom.bind(this);
    this.renderError = this.renderError.bind(this);
    this.saveKrComplete = this.saveKrComplete.bind(this);
    this.getMilestonesPayload = this.getMilestonesPayload.bind(this);
    this.handleMilestonesChange = this.handleMilestonesChange.bind(this);
    this.krMilestonesSectionRef = React.createRef();
  }

  // static getDerivedStateFromProps(props, state){
  //   if(!state.data_provider.id){
  //     let newState = {}
  //     if(props.owner.id){
  //       newState.data_provider = props.owner;
  //     }else{
  //       newState.data_provider = props.realOwner;
  //     }
  //     return {
  //       ...state,
  //       ...newState
  //     }
  //   }
  //   return null;
  // }

  componentDidUpdate(prevProps) {
    if (
      this.props.mitChildKr &&
      this.props.item &&
      this.props.item.counting != null &&
      Number(this.props.item.counting) !== Number(prevProps.item?.counting) &&
      Number(this.props.item.counting) !== Number(this.state.dsMetric)
    ) {
      this.setState({ dsMetric: parseInt(this.props.item.counting) });
    } else if (
      this.props.mitChildKr &&
      this.props.counting != null &&
      Number(this.props.counting) !== Number(prevProps.counting) &&
      Number(this.props.counting) !== Number(this.state.dsMetric)
    ) {
      this.setState({ dsMetric: parseInt(this.props.counting) });
    }
    if (this.props.krExtractInitialValue !== prevProps.krExtractInitialValue) {
      this.setState({
        initial_data: this.props.krExtractInitialValue,
        target: !this.state.isStretchEnabled ? this.props.krExtractTargetValue :'',
        dsMetric: this.props.krExtractDirectionValue,
        measureType: this.props.krExtractValueType,
        kr_name: this.props.krExtractName,
        stretch: this.state.isStretchEnabled ? this.props.krExtractTargetValue :'',
      })
    }
  }

  componentDidMount() {
    this.props.setSavedAnnualDuration(this.props.item.isQuarter,this.props.item.quarter_name,this.props.item.id)
    this.props.metricRef(this)
    document.addEventListener("mousedown", this.clickEvent, false);
    if(!this.props.comingFromTest) {
      $(".goalPopupNew").css("overflow", "hidden");
    }
    console.log('componentDidMount', 'person.component.js');
  }

  componentWillUnmount() {
		this.props.metricRef(null)
	}

  permissionData(perData) {
    this.setState({ permissionstate: perData });
  }

  teamPermissionData(teamPerData) {
    this.setState({ teamPermissionSelected: teamPerData });
  }

  bizPermissionData = (bizPerData) => {
    this.setState({ bizPermissionSelected: bizPerData });
  }

  updateDataProvider = (data) => {
    this.setState({
      data_provider: {
        id: data.userId,
        name: data.userText,
        avatar: data.userPic
      },
      checkRolFlag: false
    })
    let errors = { ...this.state.errors };
    delete errors['owner_validation'];
    this.setState({ errors });
  }

  renderError(field) {
    return (<ErrorTextComp key={field} errors={this.state.errors} field={field} />);
  }

  clickEvent(e) {
    if (
      !$(".metricmeasureArea").is(e.target) &&
      $(".metricmeasureArea").has(e.target).length === 0
    ) {
      if (this.state.MeasureEn) {
        this.setState({ MeasureEn: false });
      }

    }
    if (
      !$(".krTimeRange").is(e.target) &&
      $(".krTimeRange").has(e.target).length === 0
    ) {
      if (this.state.intervalEn) {
        this.setState({ intervalEn: false });
      }
    }
    if (
      !$(".ownerKrName").is(e.target) &&
      $(".ownerKrName").has(e.target).length === 0 &&
      (!$(".myownerAlign ").is(e.target) &&
        $(".myownerAlign").has(e.target).length === 0)
    ) {
      if (this.state.krOwnerEn) {
        this.setState({ krOwnerEn: false });
      }
    }
    if (
      !$(".CalculateOverDropDown").is(e.target) &&
      $(".CalculateOverDropDown").has(e.target).length === 0
    ) {
      if (this.state.porgressEn) {
        this.setState({ porgressEn: false });
      }
    }
    if (
      !$(".krTimeRange").is(e.target) &&
      $(".krTimeRange").has(e.target).length === 0
    ) {
      if (this.state.intervalEn) {
        this.setState({ intervalEn: false });
      }
    }
    if (
      !$(".metricTimeRange").is(e.target) &&
      $(".metricTimeRange").has(e.target).length === 0
    ) {
      if (this.state.dayEn) {
        this.setState({ dayEn: false });
      }
    }
    if (!$(".aEPermissionList").is(e.target) &&
      $(".aEPermissionList").has(e.target).length === 0) {
      if (this.state.permissonEn || this.state.subPermissonEn) {
        this.setState({ permissonEn: false, subPermissonEn: false });
      }
    } else {//for opening popup scroll to down.
      setTimeout(() => {
        var $target = $('.krRightPaneContent');
        if ($('.permissionContent').length) {
          $target.animate({ scrollTop: $('.krRightPaneContent').scrollTop() + 150 }, 1000);
        }
        if ($('.teamPermission').length) {
          $target.animate({ scrollTop: $('.krRightPaneContent').scrollTop() + 250 }, 1000);
        }
      }, 1);

    }
    if (
      !$(".metricTargetValue").is(e.target) &&
      $(".metricTargetValue").has(e.target).length === 0
    ) {
      if (this.state.metricDD) {
        this.setState({ metricDD: false });
      }
    }
  }

  handleChange(e) {
    const { name, value } = e.target;
    let stateObj = this.state;
    if (value === '' || isNumberWithComma(value)) {
      stateObj[name] = value;
      stateObj.errors = {};
      if (name == 'initial_data') {
        stateObj.isInitialDataChanged = true;
      }
      this.setState(stateObj);
    }
  }
  isSaveCustom(isVal){
    let arr=[];
    let j=0;
    let keyArrCategory=[]
    let valArray = []
    isVal && Object.keys(isVal).forEach((v)=>{
      j++;
      isVal[v]["customFields"]&&
      Object.keys(isVal[v]["customFields"]).forEach(objv=>{
        keyArrCategory.push(objv)
        if(isVal[v]["customFields"][objv]['is_required']=='1'
        &&( isVal[v]["customFields"][objv]["text"] == undefined
          || isVal[v]["customFields"][objv]["text"] === ''
          || (Array.isArray(isVal[v]["customFields"][objv]["text"]) && isVal[v]["customFields"][objv]["text"].length === 0))
        ){
             arr.push(objv,v)
            }
        if(isVal[v]["customFields"][objv]["text"]){
          valArray.push(isVal[v]["customFields"][objv]["text"])
        }else{
          valArray.push('')
            }
      })
      if(j==Object.keys(isVal).length){
        this.setState({isRequirdCustomOkr:[...arr]})
      }
      let finalDataArray=[]
      for(let i=0;i<valArray.length;i++){
        if(Array.isArray(valArray[i])){
          valArray[i].forEach(val => {
            finalDataArray.push({id:keyArrCategory[i],val:val.name,object_type:'6'})
          })
        }
        else{
          finalDataArray.push({id:keyArrCategory[i],val:valArray[i],object_type:'6'})
        }

      }
      const tempData=finalDataArray
    })

  }

  isRequiredCustomOkrFiled(isVal,id){
    let cust_id=this.state.isCustomSave.find((u) => u == id);
    let ar=this.state.isCustomSave ? this.state.isCustomSave:'';
    let fr= ar.filter(
        (u) => u != cust_id
      )
    this.setState({isCustomSave:fr})
    this.isSaveCustom(isVal)
    this.setState({customInputData:isVal})
  }

  handleErrorChange(name, value) {
    const state = this.state;
    state[name] = value;
    this.setState(state);
  }

  deleteItem() {
    //console.log('delete kr ');
    //this.props.resetKr();
  }

  // changeSourceVal(val) {
  // 	this.setState({
  // 		data_provider: {
  // 			id: val.userId,
  // 			name: val.fullName,
  // 			avatar: val.picture
  // 		},
  // 		dsMetric: val.counting
  // 	});
  // }

  filterTeamFunctions(event) {
    event?.preventDefault();
    this.setState({ _isTeamMounted: true });
    let input, filter;
    let _this = this;
    input = document.getElementById("TeamSearch");
    filter = input.value.toLowerCase();
    filter[0] === " " ? filter[0].replace(" ", "") : filter;
    filter[filter.length - 1] === " "
      ? filter[filter.length - 1].replace(" ", "")
      : filter;
    if (filter.length > 1) {
      this.GoalServices.searchTeamName({ term: filter }).then(function (
        response
      ) {
        if (response.data && _this.state._isTeamMounted) {
          _this.setState({
            _isTeamMounted: false,
            filter: {
              Team: [...response.data]
            }
          });
        }
      });
    } else {
      _this.setState({
        _isTeamMounted: false,
        filter: {
          Team: []
        }
      });
    }
  }

  selectTeam(event, valTeam) {
    let _this = this;
    _this.setState({
      teamSearchText: valTeam.name,
      for_0: valTeam.id,
      subPermissonEn: false
    });
  }

  setRightPaneValue() {
    if(this.props.goBackFromMitNestedKr){
      this.props.goBackFromMitNestedKr();
    }else{
      this.props.closeKrRightPane(false,this.state.krId);
    }
  }

  getMilestonesPayload() {
    // Ensure milestones is an array before attempting to use array methods
    if (!Array.isArray(this.state.milestones)) {
      return '';
    }
    // milestones need to be an object with keys as index and values as milestone object (for api request)
    const milestones = this.state.milestones
      .filter((milestone) => milestone.date && (milestone.target == 0 || milestone.target))
      .reduce((acc, milestone, index) => ({
        ...acc,
        [index]: {
          id: milestone.id && typeof milestone.id === 'number' ? milestone.id : null,
          date: milestone.date,
          label: milestone.label,
          target: milestone.target,
        }
      }), {});

    // if there are no milestones, return an empty string (for api request)
    return Object.keys(milestones).length > 0 ? milestones : '';
  }

  saveKr(callback = null) {
    const { t } = this.props;
    let errors = {};
    let initial_data = replaceNumericCommaValue(this.state.initial_data);
    let target = replaceNumericCommaValue(this.state.target);
    let stretch = replaceNumericCommaValue(this.state.stretch);
    let targetLowerVal = replaceNumericCommaValue(this.state.lower_limit);
    let targetUpperVal = replaceNumericCommaValue(this.state.upper_limit);
    let krText = this.props.krText;
    let krNote = this.props.krNote;
    let isError = false;
    let kr_duration=this.props.kr_duration;
    this.isSaveCustom(this.state.customInputData)
    this.setState({isCustomSave:[]})
    if (this.props.item && typeof this.props.item.trackInitialData !== 'undefined' && !this.state.isInitialDataChanged) {
      initial_data = this.props.item.trackInitialData;
    }

    // Check for milestones validation errors
    if (this.krMilestonesSectionRef.current && !this.krMilestonesSectionRef.current.validateMilestones()) {
      toastr.error(t('Milestone dates and values must be within start and target range'));
      return false;
    }
    if (krText == "") {
      isError = true;
      this.props.showMetricNameErr();
      let elem = document.getElementById("metric-name-text");
      elem.setAttribute("aria-invalid", "true");
      setTimeout(() => {
        document.getElementById("metric-name-text").focus();
      });
      return false;
    }

    // ensure the decode once method is complete
    krText = he.encode(krText);

    if (!this.props.realOwner.id) {
      isError = true;
      this.props.showMetricOwnerErr();
      return false;
    }
    if (typeof initial_data == "" || initial_data === "") {
      errors["showStartErr"] = true;
    } else if (initial_data != "" && !isNumberWithComma(initial_data)) {
      errors["showStartErr"] = true;
      this.setState({
        startValueErr: t("Please enter numeric value.")
      });
    }

    if( this.state.isRequirdCustomOkr && this.state.isRequirdCustomOkr.length>0  ){
      errors["customokr"] = t(`Please enter required field`);
      this.setState({isCustomSave:this.state.isRequirdCustomOkr})
      setTimeout(() => {
        this.setState({customFiledRequired:true})
        document.querySelector('#cutomobj')?.scrollIntoView({
          behavior: 'smooth',
        })
      }, 200)
    }

    if (this.state.dsMetric == 4) {
      if (targetLowerVal == "" || targetLowerVal == null) {
        errors["showTargetLowerErr"] = true;
      } else if (
        targetLowerVal != "" &&
        !isNumberWithComma(targetLowerVal)
      ) {
        errors["showTargetLowerErr"] = true;
        this.setState({
          lowerLimitErr: t("Please enter numeric value.")
        });
      }

      if (targetUpperVal == "" || targetUpperVal == null) {
        errors["showTargetUpperErr"] = true;
      } else if (
        targetUpperVal != "" &&
        !isNumberWithComma(targetUpperVal)
      ) {
        errors["showTargetUpperErr"] = true;
        this.setState({
          upperLimitErr: t("Please enter numeric value.")
        });
      }

      if (parseFloat(targetLowerVal) > parseFloat(targetUpperVal)) {
        errors["showTargetLowerErr"] = true;
        this.setState({
          lowerLimitErr: t("lower limit is greater than upper limit")
        });
      }
    } else {
      if (this.state.isStretchEnabled) {
        if ((target == "" || target == null) && (stretch == "" || stretch == null)) {
          errors["showTargetErr"] = true;
          errors["showStretchErr"] = true;
          this.setState({
            stretchValueErr: t("Add Value"),targetValueErr: t("Add Value")
          });
        }
      } else {
        if (target == "" || target == null) {
          errors["showTargetErr"] = true;
          this.setState({
            targetValueErr: t("Add Value")
          });
        }
      }
      if (target && !isNumberWithComma(target)) {
        errors["showTargetErr"] = true;
        this.setState({
          targetValueErr: t("Please enter numeric value.")
        });
      }
      if (stretch && !isNumberWithComma(stretch)) {
        errors["showStretchErr"] = true;
        this.setState({
          stretchValueErr: t("Please enter numeric value.")
        });
      }
      if ((target != "" && isNumberWithComma(target)) && (stretch != "" && isNumberWithComma(stretch))) {
        if ((this.state.dsMetric == 1 || this.state.dsMetric == 9) && parseFloat(stretch) < parseFloat(target)) {
          errors["showStretchErr"] = true;
          this.setState({
            stretchValueErr: t("Stretch target should be greater than committed")
          });
        }
        if ((this.state.dsMetric == 2 ||this.state.dsMetric == 8) && parseFloat(stretch) > parseFloat(target)) {
          errors["showStretchErr"] = true;
          this.setState({
            stretchValueErr: t("Stretch target should be less than committed")
          });
        }
      }

      if (this.state.dsMetric == krdetailConstants.METRIC_COUNTING_UP &&
         ((!this.state.isStretchEnabled &&
         parseFloat(initial_data) > parseFloat(target)) ||
         (this.state.isStretchEnabled &&
         (parseFloat(initial_data) > parseFloat(target) || parseFloat(initial_data) > parseFloat(stretch))))
      ) {
        errors["showStartErr"] = true;
        if (this.state.isStretchEnabled && parseFloat(initial_data) > parseFloat(target)) {
          errors['showTargetHightlightErr'] =  true;
        }
        if (this.state.isStretchEnabled && parseFloat(initial_data) > parseFloat(stretch)) {
          errors['showStretchHightlightErr'] = true;
        }
        this.setState({
          startValueErr: t("Starting value should be less than target")
        });
      } else if (!this.props.isDiabledInitialField && this.state.dsMetric == krdetailConstants.METRIC_COUNTING_DOWN &&
        ((!this.state.isStretchEnabled &&
        parseFloat(initial_data) < parseFloat(target)) ||
        (this.state.isStretchEnabled &&
        (parseFloat(initial_data) < parseFloat(target) || parseFloat(initial_data) < parseFloat(stretch))))
      ) {
        errors["showStartErr"] = true;
        if (this.state.isStretchEnabled && parseFloat(initial_data) < parseFloat(target)) {
          errors['showTargetHightlightErr'] =  true;
        }
        if (this.state.isStretchEnabled && parseFloat(initial_data) < parseFloat(stretch)) {
          errors['showStretchHightlightErr'] = true;
        }
        this.setState({
          startValueErr: t("Starting value should be greater than target")
        });
      }
      }

    // Data provider Validation
    let validateOwner = this.state.data_provider ? this.state.data_provider: this.props.realOwner;
    let validateFlag =  this.state.data_provider.id ? this.props.item.is_owner_rol : this.props.item.is_real_owner_rol;
    if (validateOwner) {
      if (validateFlag && this.state.checkRolFlag) {
        errors['owner_validation'] = `${validateOwner.name} has Read Only access and can't be assigned KRs`;
        this.setState({ checkRolFlag: false });
      } else {
        delete errors['owner_validation'];
      }
    }
    // Owner Drop down validation
    if (this.props.realOwner && this.props.realOwner.id) {
      if (this.state.checkRolFlag) {
        if (this.props.item && this.props.item.is_real_owner_rol !== undefined && this.props.item.is_real_owner_rol) {
          console.log('saveKr calling showRolErr(true)');
          this.props.showRolErr(true);
          this.setState({ checkRolFlag: false });
        } else {
          console.log('saveKr calling showRolErr(false)');
          this.props.showRolErr(false);
        }
      } else {
        console.log('saveKr checkRolFlag is false, calling showRolErr(false)');
        this.props.showRolErr(false);
      }
    }

    if (!isKrTimespanWithinObjective(this.props.kr_duration, this.props.goalDetails)) {
      errors.kr_timespan = t('Key result timespan must be fully within Objective timespan.');
    }

    if (Object.keys(errors).length) {
      this.setState({ errors });
      if (errors.kr_timespan) {
        toastr.error(errors.kr_timespan);
      }
      if (errors.metricName) {
        $('.krRightPaneContent').parent().animate({ scrollTop: 0 });
      }
    } else {
      if (krText == "") {
        return false;
      }
      if(this.props.lastType != this.props.krType
				&& this.props.lastType !== 'krstudio' // no alert when going from krstudio to person, ww-11221
        && (this.props.lastType == 'kpi' || this.props.lastType == 'person')
				&& this.props.addEditFlag){
        this.setState({
          externalSource: true,
          titleRetain: "",
          contentRetain: "",
        })
      }
      const dataTypeChanged = this.props.lastType != this.props.krType
        && this.props.lastType !== 'krstudio' // no alert when going from krstudio to person, ww-11221
        && this.props.addEditFlag;
      const cadenceChanged = this.state.intervalType != this.props.item.interval && this.props.addEditFlag;
      const timePeriodChanged = !this.props.mitChildKr
        && isKrDurationChangedFromSaved(this.props.item, this.props.kr_duration, this.props.goalDetails);
      const caution = resolveKrCaution({ dataTypeChanged, timePeriodChanged, cadenceChanged });

      if (caution === KR_CAUTION.DELETE_ONLY) {
        this.setState({
          confirmPopup: true,
          isAnuualQChange: timePeriodChanged,
          cadenceChanged,
        })
      } else if (caution === KR_CAUTION.DELETE_OR_RETAIN) {
        this.setState({
          intervalConfirmPopup: true,
          isAnuualQChange: false,
          cadenceChanged,
        });
      } else {
        let params = {
          type: WbEventHandlerMixins.getInverseKrType(this.props.krType) || KR_TYPES[1],
        };
        let krAlignSel = this.state.krAlingSelected;
        let dependentKrsSel = this.state.krDependenciesSelected;
        let krAligns = [];
        let dependentKrs = [];

        if (Object.keys(krAlignSel).length > 0) {
          krAlignSel.map(item => {
            krAligns.push(item.id);
          });
        }

        if (Object.keys(dependentKrsSel).length > 0) {
          dependentKrsSel.map(item => {
            dependentKrs.push(item.id);
          });
        }
        params["nested_krs"] = constructNestedKRPayload(this.props);
        params.krAligns = krAligns;
        params.dependentKr = dependentKrs;
        // Include milestones data if available
        params.milestones = this.getMilestonesPayload();
        if (this.state.dsMetric == 4) {
          params.lower_limit = replaceNumericCommaValue(this.state.lower_limit);
          params.upper_limit = replaceNumericCommaValue(this.state.upper_limit);
          params.progress_type = 1;
        } else {
          params.target = replaceNumericCommaValue(this.state.target);
          if(this.state.isStretchEnabled) {
            params.stretch_target  = replaceNumericCommaValue(this.state.stretch);
          }
          params.progress_type = this.state.progType;
        }
        params.name = krText;
        params.description = krNote;
        params.kr_duration=kr_duration;
        params.isQuarter=this.props.isQuarter;
        params.owner = this.state.data_provider.id ? this.state.data_provider.id : this.props.realOwner.id;
        params.real_owner = this.props.showRealOwner ? this.props.realOwner.id : params.owner;
        let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
        params.coOwners = coOwners.length > 0 ? Array.prototype.map
          .call(coOwners, s => s.id)
          .toString() : '';
        params.metric = this.state.measureType;
        params.initial_data = replaceNumericCommaValue(this.state.initial_data);
        params.counting = this.state.dsMetric;
        params.interval = this.state.intervalType;
        let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
        let tagids=this.state.tags.length ? this.state.tags : ['']
        let finalTagsIds = [...nlpIds,...tagids]
        params.krTagIds = finalTagsIds;
        params.customField = JSON.stringify(this.props.customFieldsData);
        if (isWeeklyInterval(this.state.intervalType)) {
          params.weekly_update_day = this.state.dayType;
        }

        params.source = 1;
        params.progress_consider = this.state.Exclude ? 0 : 1;

        let teaMperArr = [], bizPerArr = [];

        // if (this.state.teamPermissionSelected && this.state.teamPermissionSelected.length > 0) {
        //   this.state.teamPermissionSelected.map(val => teaMperArr.push(val.id));
        // }

        if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
          const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
          if (Array.isArray(permission_teams) && permission_teams.length) {
            teaMperArr = permission_teams.map(val => val.id);
          }
          if (Array.isArray(permission_biz) && permission_biz.length) {
            bizPerArr = permission_biz.map(val => val.id);
          }
        } else {
          teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
          bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
        }
        params.permission_teams = teaMperArr;
        params.permission_biz = bizPerArr;

        if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
          params.permission = this.props.goalDetails.permission;
        } else {
          params.permission = Array.prototype.map
            .call(this.state.permissionstate, s => s)
            .toString(); // "A,B,C";
        }

        let goalId = this.props.goalDetails.id;
        if (this.props.item && this.props.item.id) {
          params.id = this.props.item.id;
        }
        if(!this.state.isStretchEnabled || this.state.dsMetric == 4) {
          params.committed_target = this.state.committedKRFlag == 1 ? 1 : 0;
        }

        // For Custom duration
        // The start and end date need to remain NULL unless they are truly custom dates on the metric
        const goalStartMoment = moment(this.props.goalDetails.start_date).utc().startOf('day');
        const goalEndMoment = moment(this.props.goalDetails.target_date).utc().startOf('day');
        const krStartMoment = this.props.kr_duration?.start ? moment(this.props.kr_duration.start).utc().startOf('day') : null;
        const krEndMoment = this.props.kr_duration?.end ? moment(this.props.kr_duration.end).utc().startOf('day') : null;

        const hasCustomDuration = krStartMoment && krEndMoment &&
          (krStartMoment.isAfter(goalStartMoment) || krEndMoment.isBefore(goalEndMoment));

        params.start_date = hasCustomDuration ? this.props.kr_duration.start : null;
        params.end_date = hasCustomDuration ? this.props.kr_duration.end : null;

        params.predicted_initial_data = this.props.krExtractInitialValue;
        params.predicted_target = this.props.krExtractTargetValue;
        params.predicted_metric = this.props.krExtractValueType;
        params.predicted_direction = this.props.krExtractDirectionValue;
        params.predicted_name = this.props.krExtractName;
        params.predicted = this.props.predicted ? 'yes' : 'no';
        //if(this.props.isChildKr && !this.props.item.parent ){
        if(this.props.isChildKr && this.props.fromParentKr){
          params.ownerName = this.state.data_provider.id ? this.state.data_provider.name : this.props.realOwner.name;
          params.duration = this.props.childKrDuration;
          params.owner_fullname = this.state.data_provider.id ? this.state.data_provider.name : this.props.realOwner.name;
          params.owner_pic = this.state.data_provider.id ? this.state.data_provider.avatar : this.props.realOwner.avatar;
          params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
          params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
          params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
          if(this.props.item.parent){
            params.parent = this.props.item.parent;
          }
          this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
        } else if(this.props.mitChildKr){
          params.counting = this.props.item?.counting ?? this.props.counting ?? this.state.dsMetric;
          params.ownerName = this.state.data_provider.id ? this.state.data_provider.name : this.props.realOwner.name;
          params.duration = this.props.childKrDuration;
          params.owner_fullname = this.state.data_provider.id ? this.state.data_provider.name : this.props.realOwner.name;
          params.owner_picture = this.state.data_provider.id ? this.state.data_provider.avatar : this.props.realOwner.avatar;
          params.owner_pic = this.state.data_provider.id ? this.state.data_provider.avatar : this.props.realOwner.avatar;
          params.picture = this.state.data_provider.id ? this.state.data_provider.avatar : this.props.realOwner.avatar;
          params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
          params.real_owner_picture = this.props.showRealOwner ? this.props.realOwner.avatar : "";
          params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
          this.props.saveQuarterlyKR(params, this.props.mitIndex);
          this.saveKrComplete(callback, params);
        } else {
          if(this.props.item.parent){
            params.start_date = this.props.childKrDuration.start ;
            params.end_date = this.props.childKrDuration.end;
            params.parent = this.props.item.parent;
          }
          reactLoader(true);
          let { actions } = this.props;
          this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
            response => {
              removeReactLoader();
              if (response.data?.err) {
                alert(response.data.err);
                return;
              }
              if (response.data) {
                if (!this.props.onlyMetEdit) {
                  let result = response.data.data;

                  // we encoded before the save, we must decode after
                  result.name = he.decode(result.name);

                  let krWeightage = null;
                  if (result.krWeightage) {
                    krWeightage = result.krWeightage;
                    delete result['krWeightage'];
                  }
                  result = {
                      clusterItems: this.props.clusterData,
                      clusterCount: this.props.clusterData.length,
                      ...result
                  };
                  if(result.parent){
                    actions.addUpdateNestedKr(result)
                  }else{
                    if (this.state.krId != "") {
                      actions.editNewKr(this.state.krId, result);
                    } else {
                      actions.addNewKr(result);
                    }
                  }
                  if (krWeightage) {
                    this.props.MetricChangeWeight(krWeightage);
                  }
                }
                if(this.props.isChildKr){
                  this.props.updateNestedKrs(response.data.data, "add")
                }
                this.saveKrComplete(callback, response.data.data);
                // this.GoalServices.triggerGoalMetricDetails({goalId});
              }
            }
          );
        }

      }
    }
  }

  saveKrComplete(callback = null, data = {}) {
    if (!this.props.mitChildKr) {
      window.dispatchEvent(new CustomEvent('krDataRefresh'));
    }
    if (callback && typeof callback === 'function') {
      callback(data);
    } else {
      this.props.closeKrRightPane(true);
    }
  }

  exitDeleteModal() {
    this.setState({ confirmPopup: false, intervalConfirmPopup: false, externalSource: false });
  }

  deleteItems() {
    this.setState({selectedType: 1}, this.saveItems);
  }


  saveItems() {
    let errors = {};
    const {t} = this.props;
    let initial_data = replaceNumericCommaValue(this.state.initial_data);
    let target = replaceNumericCommaValue(this.state.target);
    let stretch = replaceNumericCommaValue(this.state.stretch);
    let targetLowerVal = replaceNumericCommaValue(this.state.lower_limit);
    let targetUpperVal = replaceNumericCommaValue(this.state.upper_limit);
    let krText = this.props.krText;
    let krNote = this.props.krNote;
    let kr_duration=this.props.kr_duration;
    let isError = false;
    if (krText == "") {
      isError = true;
      this.props.showMetricNameErr();
      return false
    }

    if (typeof initial_data == "" || initial_data === "") {
      errors["showStartErr"] = true;
    } else if (initial_data != "" && !isNumberWithComma(initial_data)) {
      errors["showStartErr"] = true;
      this.setState({
        startValueErr: t("Please enter numeric value.")
      });
    }

    if (this.state.dsMetric == 4) {
      if (targetLowerVal == "" || targetLowerVal == null) {
        errors["showTargetLowerErr"] = true;
      } else if (
        targetLowerVal != "" &&
        !isNumberWithComma(targetLowerVal)
      ) {
        errors["showTargetLowerErr"] = true;
        this.setState({
          lowerLimitErr: t("Please enter numeric value.")
        });
      }

      if (targetUpperVal == "" || targetUpperVal == null) {
        errors["showTargetUpperErr"] = true;
      } else if (
        targetUpperVal != "" &&
        !isNumberWithComma(targetUpperVal)
      ) {
        errors["showTargetUpperErr"] = true;
        this.setState({
          upperLimitErr: t("Please enter numeric value.")
        });
      }

      if (parseFloat(targetLowerVal) > parseFloat(targetUpperVal)) {
        errors["showTargetLowerErr"] = true;
        this.setState({
          lowerLimitErr: t("lower limit is greater than upper limit")
        });
      }
    } else {
      if (this.state.isStretchEnabled) {
        if ((target == "" || target == null) && (stretch == "" || stretch == null)) {
          errors["showTargetErr"] = true;
          errors["showStretchErr"] = true;
          this.setState({
            stretchValueErr: t("Add Value"),targetValueErr: t("Add Value")
          });
        }
      } else {
        if (target == "" || target == null) {
          errors["showTargetErr"] = true;
        }
      }

      if (target && !isNumberWithComma(target)) {
        errors["showTargetErr"] = true;
        this.setState({
          targetValueErr: t("Please enter numeric value.")
        });
      }
      if (stretch && !isNumberWithComma(stretch)) {
        errors["showStretchErr"] = true;
        this.setState({
          stretchValueErr: t("Please enter numeric value.")
        });
      }
      if ((target && isNumberWithComma(target)) && (stretch && isNumberWithComma(stretch))) {
        if ((this.state.dsMetric == 1 || this.state.dsMetric == 9) && parseFloat(stretch) < parseFloat(target)) {
          errors["showStretchErr"] = true;
          this.setState({
            stretchValueErr: t("Stretch target should be greater than committed")
          });
        }
        if ((this.state.dsMetric == 2 ||this.state.dsMetric == 8) && parseFloat(stretch) > parseFloat(target)) {
          errors["showStretchErr"] = true;
          this.setState({
            stretchValueErr: t("Stretch target should be less than committed")
          });
        }
      }
      if (this.state.dsMetric == 1 &&
          ((!this.state.isStretchEnabled &&
          parseFloat(initial_data) > parseFloat(target)) ||
          (this.state.isStretchEnabled &&
          (parseFloat(initial_data) > parseFloat(target) || parseFloat(initial_data) > parseFloat(stretch))))
      ) {
        errors["showStartErr"] = true;
        if (this.state.isStretchEnabled && parseFloat(initial_data) > parseFloat(target)) {
          errors['showTargetHightlightErr'] =  true;
        }
        if (this.state.isStretchEnabled && parseFloat(initial_data) > parseFloat(stretch)) {
          errors['showStretchHightlightErr'] = true;
        }
        this.setState({
          startValueErr: t("Starting value should be less than target")
        });
      } else if (this.state.dsMetric == 2 &&
         ((!this.state.isStretchEnabled &&
          parseFloat(initial_data) < parseFloat(target)) ||
          (this.state.isStretchEnabled &&
          (parseFloat(initial_data) < parseFloat(target) || parseFloat(initial_data) < parseFloat(stretch))))
      ) {
        errors["showStartErr"] = true;
        if (this.state.isStretchEnabled && parseFloat(initial_data) < parseFloat(target)) {
          errors['showTargetHightlightErr'] =  true;
        }
        if (this.state.isStretchEnabled && parseFloat(initial_data) < parseFloat(stretch)) {
          errors['showStretchHightlightErr'] = true;
        }
        this.setState({
          startValueErr: t("Starting value should be greater than target")
        });
      }
    }

    if (!isKrTimespanWithinObjective(this.props.kr_duration, this.props.goalDetails)) {
      errors.kr_timespan = t('Key result timespan must be fully within Objective timespan.');
    }

    if (Object.keys(errors).length) {
      this.setState({ errors });
      if (errors.kr_timespan) {
        toastr.error(errors.kr_timespan);
      }
      if (errors.metricName) {
        $('.krRightPaneContent').parent().animate({ scrollTop: 0 });
      }
    } else {
      let params = {
        type: WbEventHandlerMixins.getInverseKrType(this.props.krType) || KR_TYPES[1],
      };
      params.clearCache = this.state.cadenceChanged;
      if (this.state.dsMetric == 4) {
        params.lower_limit = replaceNumericCommaValue(this.state.lower_limit);
        params.upper_limit = replaceNumericCommaValue(this.state.upper_limit);
        params.progress_type = 1;
      } else {
        params.target = replaceNumericCommaValue(this.state.target);
        params.progress_type = this.state.progType;
        if(this.state.isStretchEnabled) {
          params.stretchTarget = replaceNumericCommaValue(this.state.stretch);
        }
      }
      params.name = krText;
      params.description = krNote;
      params.kr_duration=kr_duration;
      // For Custom duration
      params.start_date = kr_duration?.start;
      params.end_date = kr_duration?.end;
      params.isQuarter=this.props.isQuarter;
      params.isPeriodChange=this.state.isAnuualQChange
      params.owner = this.state.data_provider.id ? this.state.data_provider.id : this.props.realOwner.id;
      params.real_owner = this.props.showRealOwner ? this.props.realOwner.id : params.owner;
      let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
      params.coOwners = coOwners.length > 0 ? Array.prototype.map
        .call(coOwners, s => s.id)
        .toString() : '';
      params.metric = this.state.measureType;
      params.initial_data = replaceNumericCommaValue(this.state.initial_data);
      params.counting = this.state.dsMetric;
      params.interval = this.state.intervalType;

      if (isWeeklyInterval(this.state.intervalType)) {
        params.weekly_update_day = this.state.dayType;
      }

      params.source = 1;
      params.progress_consider = this.state.Exclude ? 0 : 1;

      let teaMperArr = [], bizPerArr = [];

      // if (this.state.teamPermissionSelected && this.state.teamPermissionSelected.length > 0) {
      //   this.state.teamPermissionSelected.map(val => teaMperArr.push(val.id));
      // }

      if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
        const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
        if (Array.isArray(permission_teams) && permission_teams.length) {
          teaMperArr = permission_teams.map(val => val.id);
        }
        if (Array.isArray(permission_biz) && permission_biz.length) {
          bizPerArr = permission_biz.map(val => val.id);
        }
      } else {
        teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
        bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
      }
      params.permission_teams = teaMperArr;
      params.permission_biz = bizPerArr;
      if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
        params.permission = this.props.goalDetails.permission;
      } else {
        params.permission = Array.prototype.map
          .call(this.state.permissionstate, s => s)
          .toString(); // "A,B,C";
      }

      let goalId = this.props.goalDetails.id;
      if (this.props.item && this.props.item.id) {
        params.id = this.props.item.id;
      }

      let krAlignSel = this.state.krAlingSelected;
      let dependentKrsSel = this.state.krDependenciesSelected;
      let krAligns = [];
      let dependentKrs = [];

      if (Object.keys(krAlignSel).length > 0) {
        krAlignSel.map(item => {
          krAligns.push(item.id);
        });
      }

      if (Object.keys(dependentKrsSel).length > 0) {
        dependentKrsSel.map(item => {
          dependentKrs.push(item.id);
        });
      }
      params["nested_krs"] = constructNestedKRPayload(this.props);
      params.krAligns = krAligns;
      params.dependentKr = dependentKrs;
      // Include milestones data if available
      params.milestones = this.getMilestonesPayload();
      params.retainUpdates = this.state.selectedType ? this.state.selectedType : '' ;
      params.customField = JSON.stringify(this.props.customFieldsData);
      let { actions } = this.props;
      if(this.props.isChildKr && this.props.fromParentKr){
        params.ownerName = this.state.data_provider.id ? this.state.data_provider.name : this.props.realOwner.name;
        params.duration = this.props.childKrDuration;
        params.owner_fullname = this.state.data_provider.id ? this.state.data_provider.name : this.props.realOwner.name;
        params.owner_pic = this.state.data_provider.id ? this.state.data_provider.avatar : this.props.realOwner.avatar;
        params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
        params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
        if(this.props.item.parent){
          params.parent = this.props.item.parent;
        }
        params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
        this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
      } else if(this.props.mitChildKr){
        params.counting = this.props.item?.counting ?? this.props.counting ?? this.state.dsMetric;
        params.ownerName = this.state.data_provider.id ? this.state.data_provider.name : this.props.realOwner.name;
        params.duration = this.props.childKrDuration;
        params.owner_fullname = this.state.data_provider.id ? this.state.data_provider.name : this.props.realOwner.name;
        params.owner_picture = this.state.data_provider.id ? this.state.data_provider.avatar : this.props.realOwner.avatar;
        params.owner_pic = this.state.data_provider.id ? this.state.data_provider.avatar : this.props.realOwner.avatar;
        params.picture = this.state.data_provider.id ? this.state.data_provider.avatar : this.props.realOwner.avatar;
        params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
        params.real_owner_picture = this.props.showRealOwner ? this.props.realOwner.avatar : "";
        params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
        this.props.saveQuarterlyKR(params, this.props.mitIndex);
        this.props.closeKrRightPane();
      } else{
        if(this.props.item.parent){
          params.start_date = this.props.childKrDuration.start ;
          params.end_date = this.props.childKrDuration.end;
          params.parent = this.props.item.parent;
        }
        reactLoader(true);
        this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
          response => {
            removeReactLoader();
            if (response.data?.err) {
              alert(response.data.err);
              return;
            }
            if (response.data) {
              this.setState({
                confirmPopup: false,
                intervalConfirmPopup: false,
                externalSource: false,
                isAnuualQChange:false,
              });
              if (!this.props.onlyMetEdit) {
                let result = response.data.data;
                let krWeightage = null;
                if (result.krWeightage) {
                  krWeightage = result.krWeightage;
                  delete result['krWeightage'];
                }
                result = {
                    clusterItems: this.props.clusterData,
                    clusterCount: this.props.clusterData.length,
                    ...result
                };
                if(result.parent){
                  actions.addUpdateNestedKr(result)
                }else{
                  if (this.state.krId != "") {
                    actions.editNewKr(this.state.krId, result);
                  } else {
                    actions.addNewKr(result);
                  }
                }

                if (krWeightage) {
                  this.props.MetricChangeWeight(krWeightage);
                }
              }
              this.props.closeKrRightPane(true);
              // this.GoalServices.triggerGoalMetricDetails({goalId});
            }
          }
        );
      }
    }
  }

  handleExcludeChange() {
    this.setState({ Exclude: !this.state.Exclude });
  }

  toggelePermission() {
    this.setState({ permissonEn: true });
  }

  toggeleSubPermission() {
    this.setState({ subPermissonEn: true, permissonEn: true });
  }

  targetClick(e, id) {
    this.setState({ dsMetric: id, errors: {} });
  }

  saveAlignArr(alignData) {
    this.setState({ krAlingSelected: alignData });
  }

  saveDependentArr(dependentData) {
    this.setState({ krDependenciesSelected: dependentData });
  }

  handleCommittedKRChange = () => {
    this.setState({ committedKRFlag: this.state.committedKRFlag == 1 ? 0 : 1 });
  }

  saveTag = (childData) =>{
    this.setState({tags:childData})
  }

  changeRadio(value) {
    this.setState({ selectedType: value });
  }

  updateTags(Newtags){
    this.setState({ selectednlplTagsName: Newtags });
  }

  handleMilestonesChange(milestones) {
    this.setState({ milestones });
  }

  render() {
    const {t} = this.props;
    let defaultInterval = Number(this.state.intervalType);
    let dsProg = [
      {
        value: 1,
        name : t("Last entered value"),
      },
      {
        value: 2,
        name : t("Total of all entered values")
      },
      {
        value: 3,
        name : t("Average of all entered values")
      }
    ];
    let basicMeasure = [
      {
        value: 1,
        name : t("Count as number")
      },
      {
        value: 2,
        name : t("Count as currency")
      },
      {
        value: 3,
        name : t("Count as percentage")
      }
    ];
    let basicInterval = IntervalTexts;
    let basicIntervalArr = getIntervalOptions('default', this.props.addOkrData.isEnabledBiweeklyKR, false, defaultInterval === krdetailConstants.INTERVAL_BIQUARTERLY);
    let basicDays = getWeekDaysOptions();
    let errors = this.state.errors;
    let isErrors = Object.keys(errors).length;
    const peopleResponsible = this.props.mitChildKr ? t('Person Responsible for updating') : t('Who will measure progress and how often') +'?';
    let initialData = this.state.initial_data;
    const { item } = this.props;
    const isScoringLocked = Number(item?.status) === krdetailConstants.METRIC_CLOSED;
    if (item && typeof item.trackInitialData !== 'undefined' && !this.state.isInitialDataChanged) {
      initialData = item.trackInitialData;
    }
    let upperLimitText = t('Target upper limit ')
    let lowerLimitText = t('Target lower limit')
    return (
      <div className={!this.state.isStretchEnabled ? "basickrModal" : "basickrModal marginT35"}>
        <form onSubmit={this.saveKr}>
          <div>
            {this.props.switchedFromMit &&
              <div>
                <span className={"krHeadText"}>{t('OVERALL TARGET')}</span>
              </div>
            }
            <div className=" basickrstarttargets basic-flex-box" style={{alignItems: 'flex-start', marginBottom: 20 }}>
              <div className={(!this.state.isStretchEnabled || !isErrors) ? "basic-flex-content marginR12" : "basic-flex-content marginR5 error-width-basic-kr"} style={{width:`${!this.state.isStretchEnabled ? '96px' : '119px'}`}}>
                <div className="metrictargettext marginB5 marginNone" id="singleKR-startValue">
                  {t('Starting from')} <span className="text-style-1">*</span>
                </div>
                <Textfield
                  type="text"
                  aria-labelledby="singleKR-startValue"
                  name="initial_data"
                  ref="initial_data"
                  isError={isErrors && typeof errors["showStartErr"] !== "undefined" ? true : false}
                  helperText={isErrors && typeof errors["showStartErr"] !== "undefined" ? this.state.startValueErr : null}
                  className={this.state.isStretchEnabled ? "text-target-field stretch-text-target-width" : "text-target-field kr-text-target-field text-target-width"}
                  value={initialData}
                  onChange={this.handleChange}
                  autoComplete="off"
                  isDisabled={this.props.isDiabledInitialField || isScoringLocked}
                />
              </div>
              <div className="basic-flex-content marginR12">
                <div className="krs-target-value-text marginNone marginB5">
                  {t('Result value')}
                  {" "}
                  <HelpTextComp>
                    <div className="targetHelp">
                      <span className="dot inLineBlk" />
                      <span className="targetHelpDec inLineBlk">
                        <strong>{t('Should increase to')} </strong>
                        {t('example')+': '}{t('Starting from 0 MQLs moving to 10 MQLs')}
                      </span>
                    </div>
                    <div className="targetHelp">
                      <span className="dot inLineBlk" />
                      <span className="targetHelpDec inLineBlk">
                        <strong>{t('Should decrease to')} </strong>
                        {t('example')+': '}{t('Starting from 100 bugs moving to 10 bugs')}
                      </span>
                    </div>
                    <div className="targetHelp">
                      <span className="dot inLineBlk" />
                      <span className="targetHelpDec inLineBlk">
                        <strong>{t('Should be equal to')} </strong>
                        {t('example')+': '}{t('When you have an exact number to hit, like hiring exactly 10 developers - not less, not more')}
                      </span>
                    </div>
                    <div className="targetHelp">
                      <span className="dot inLineBlk" />
                      <span className="targetHelpDec inLineBlk">
                        <strong>{t('Should fall within a range')} </strong>
                        {t('example')+': '}{t('Starting from $0 aiming to move towards a range of $10-$15')}
                      </span>
                    </div>
                  </HelpTextComp>
                </div>
                <StyledDropdown
                  options={getTargetValue()}
                  onChange={(e) => { this.targetClick(e, e.target["value"]) }}
                  id={"result-value-dropdown"}
                  data-testid={"result-value-dropdown"}
                  value={Number(
                    this.props.mitChildKr && this.props.item?.counting != null
                      ? this.props.item.counting
                      : this.props.mitChildKr && this.props.counting != null
                      ? this.props.counting
                      : this.state.dsMetric
                  )}
                  aria-label={t('Result Value')}
                  showStartNodeOnSelect
                  optionTitleProp="name"
                  optionValueProp="value"
                  disabled={!!this.props.mitChildKr || isScoringLocked}
                  MenuProps={{
                    style: {
                      zIndex: '1500000'
                    }
                  }}
                />
              </div>
              {this.state.dsMetric != 4 && (
                <div className={!this.state.isStretchEnabled ? "basic-flex-content" : "target-input-box marginT22"}>
                <div className={!this.state.isStretchEnabled ? "metric-target-text marginB5" : "marginB5 stretch-target-text"} id="singleKR-target">
                    {t('Target value')} <span className="text-style-1">*</span>
                  </div>
                    { this.state.isStretchEnabled &&  this.state.dsMetric != 4 && (
                      <div className="metric-target-text marginB5 widthFitContent">
                        {t('Committed target')}
                        <HelpTextComp popUpClass={this.state.dsMetric == 4 ? "rightAlign" : "leftAlign"} wrapperClass="committedKRHelpText marginL3">
                          {t('When you set a Committed Result, the RAG status will follow a more aggressive curve throughout the quarter, and your progress at the end of the quarter will only be green if you achieve 100% of your target.')} {t('This is helpful for financial targets, SLAs, or similar targets that you have a commitment to hit.')}
                        </HelpTextComp>
                      </div>
                    )}
                  <Textfield
                    type="text"
                    aria-labelledby="singleKR-target"
                    name="target"
                    ref="target"
                    id="personTarget"
                    className={this.state.isStretchEnabled ? "text-target-field stretch-text-target-width" : "text-target-field text-target-width"}
                    placeholder={t("Enter Value")}
                    isError={isErrors && (typeof errors["showTargetErr"] !== "undefined" || typeof errors["showTargetHightlightErr"] !== "undefined") ? true : false}
                    helperText={isErrors && typeof errors["showTargetErr"] !== "undefined" ? this.state.targetValueErr : null}
                    data-testid="metric-end-value"
                    value={this.state.target}
                    onChange={this.handleChange}
                    autoComplete="off"
                    isDisabled={isScoringLocked}
                  />
                </div>
              )}
              {this.state.dsMetric != 4 && this.state.isStretchEnabled && (
                <div className="target-input-box" style={{marginTop: '1px'}}>
                  <div className="metric-target-text marginB5 widthFitContent">
                    {t('Stretch target')}
                    <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3">
                      {t('Aim for best possible! Your stretch target is what you aspire to achieve beyond what has been committed')}
                    </HelpTextComp>
                  </div>
                  <Textfield
                    type="text"
                    aria-labelledby="singleKR-target"
                    name="stretch"
                    ref="stretch"
                    className="text-target-field stretch-text-target-width"
                    placeholder={t("Enter Value")}
                    isError={isErrors && (typeof errors["showStretchErr"] !== "undefined" || typeof errors["showStretchHightlightErr"] !== "undefined") ? true : false}
                    helperText={isErrors && typeof errors["showStretchErr"] !== "undefined" ? this.state.stretchValueErr : null}
                    data-testid="metric-end-value"
                    value={this.state.stretch}
                    onChange={this.handleChange}
                    autoComplete="off"
                    isDisabled={isScoringLocked}
                  />
                </div>
              )}
              {this.state.dsMetric == 4 && (
                <div className="basic-flex-content" style={{gap:lowerLimitText.length>18 && '8px'}}>
                  <div className="metric-lower-text marginB5" id="singleKR-lower-target">
                    {lowerLimitText} <span className="text-style-1">*</span>
                  </div>
                  <Textfield
                    type="text"
                    name="lower_limit"
                    ref="lower_limit"
                    className="text-target-field upper-lower"
                    isError={isErrors && typeof errors["showTargetLowerErr"] !== "undefined" ? true : false}
                    helperText={isErrors && typeof errors["showTargetLowerErr"] !== "undefined" ? this.state.lowerLimitErr : null}
                    data-testid="metric-lower-value"
                    value={this.state.lower_limit}
                    onChange={this.handleChange}
                    autoComplete="off"
                    isDisabled={isScoringLocked}
                  />
                </div>
              )}
              {this.state.dsMetric == 4 && (
                <div className="basic-flex-content" style={{gap:lowerLimitText.length>18 && '8px'}}>
                  <div className="metric-uppert-text marginB5" id="singleKR-upper-target">
                    {upperLimitText}<span className="text-style-1">*</span>
                  </div>
                  <Textfield
                    type="text"
                    name="upper_limit"
                    ref="upper_limit"
                    className="text-target-field upper-lower"
                    isError={isErrors && typeof errors["showTargetUpperErr"] !== "undefined" ? true : false}
                    helperText={isErrors && typeof errors["showTargetUpperErr"] !== "undefined" ? this.state.upperLimitErr : null}
                    data-testid="metric-upper-value"
                    value={this.state.upper_limit}
                    onChange={this.handleChange}
                    autoComplete="off"
                    isDisabled={isScoringLocked}
                  />
                </div>
              )}
              { (!this.state.isStretchEnabled || this.state.dsMetric == 4) ? <div className={"committedKRWrapper"  + (this.state.dsMetric == 4 ? " rangeCheckbox": "")} style={{marginTop: 20}}><StyledCheckbox
                    id="committedKR"
                    className="committedCheckBox"
                    label={`${t('Committed')} ${t('result')}`}
                    isChecked={this.state.committedKRFlag == 1 ? true : false}
                    onClick={this.handleCommittedKRChange}
                    isDisabled={!!this.props.mitChildKr || isScoringLocked}
                    />
                  <HelpTextComp popUpClass={this.state.dsMetric == 4 ? "rightAlign" : "leftAlign"} wrapperClass="committedKRHelpText">
                    {t('When you set a Committed Result, the RAG status will follow a more aggressive curve throughout the quarter, and your progress at the end of the quarter will only be green if you achieve 100% of your target.')} {t('This is helpful for financial targets, SLAs, or similar targets that you have a commitment to hit.')}
                  </HelpTextComp>
                </div> : ''
              }
            </div>

            {/* Row: Measurement unit and agregation */}
            <div className="flex-row-left marginB16">
            {!this.props.mitChildKr &&
              <div className="flex-item marginR12">
                <div className="CalculateOver" id="unit-mesure">
                  {t('Unit of measurement')} <span className="typefacetext">*</span>
                </div>
                <StyledDropdown
                  data-testid="myAlign"
                  id="unit-measure-dropdown"
                  aria-labelledby="unit-mesure"
                  value={Number(this.state.measureType)}
                  autoMenuWidth
                  disabled={isScoringLocked}
                  onChange={(event) => {
                    this.setState({ measureType: event.target["value"] });
                  }}
                  optionTitleProp="name"
                  optionValueProp="value"
                  options={basicMeasure}
                  MenuProps={{
                    style: {
                      zIndex: '1500000'
                    },
                  }}
                />
              </div>
            }
              {this.state.dsMetric != 4 && (
                <div className="flex-item">
                  <div className="CalculateOverAll">
                    <span id="cal-overall">
                      {t('Calculate overall progress as')}
                      <HelpTextComp popUpClass={"leftAlign"} wrapperClass="CalculateOverAllHelpIcon">
                        <div>
                          <div className="targetHelp">
                            <span className="dot inLineBlk" />
                            <span className="targetHelpDec inLineBlk">
                              <strong>{t('Last entered value')}: </strong>{t(`If a user entered "4" for the last update, the overall progress would also show "4".`)}
                            </span>
                          </div>
                          <div className="targetHelp">
                            <span className="dot inLineBlk" />
                            <span className="targetHelpDec inLineBlk">
                              <strong>{t('Total of all entered values')}: </strong>{t(`If a user entered "2", "3" and "4" for all of their updates, the overall progress would show "9".`)}
                          </span>
                          </div>
                          <div className="targetHelp">
                            <span className="dot inLineBlk" />
                            <span className="targetHelpDec inLineBlk">
                              <strong>{t('Average of all entered values')}: </strong>{t(`If a user entered "2", "3" and "4" for all of their updates, the overall progress would show "3".`)}
                          </span>
                          </div>
                        </div>
                      </HelpTextComp>
                    </span>
                  </div>
                  <StyledDropdown
                    data-testid="CalculateOverDropDown"
                    id="cal-overall-dropdown"
                    aria-labelledby="cal-overall"
                    value={Number(this.state.progType)}
                    autoMenuWidth
                    disabled={isScoringLocked}
                    onChange={(event) => {
                      this.setState({ progType: event.target["value"] });
                    }}
                    optionTitleProp="name"
                    optionValueProp="value"
                    options={dsProg}
                    MenuProps={{
                      style: {
                        zIndex: '1500000'
                      },
                    }}
                  />
                </div>
              )}
            </div>
            {/* Row end: Measurement unit and agregation */}

            <div className="Person-responsible-f">
              {peopleResponsible} <span className="typefacetext">*</span></div>
            <div className="metrictarttargetsec">
              <MetricOwnerCommonModal teamId={this.props.addOkrData.goalDetails.team_id } addId="personMetrictarttargetsecId" key={this.props.realOwner.id} item={this.state.data_provider.id ? this.state.data_provider : this.props.realOwner} updateData={this.updateDataProvider} scrollElClass="krRightPaneContent" />
              {this.renderError('owner_validation')}
              {!this.props.mitChildKr && <>
              <div className="verticalTop krToUpdate inLineBlk">{t('to update')}</div>
              <StyledDropdown
                data-testid="myAlign"
                id="select-interval-dropdown"
                aria-label={t("How often to update")+'?'}
                value={defaultInterval}
                autoMenuWidth
                disabled={isScoringLocked}
                onChange={(event) => {
                  this.setState({ intervalType: event.target["value"] });
                }}
                optionTitleProp="name"
                optionValueProp="value"
                options={basicIntervalArr}
                MenuProps={{
                  style: {
                  zIndex: '1500000'
                  },
                }}
              />
              {(isWeeklyInterval(this.state.intervalType))&& (
                <div className="verticalTop onMetric inLineBlk">{t('On')}</div>
              )}
              {(isWeeklyInterval(this.state.intervalType)) && (
                <StyledDropdown
                  data-testid="myAlign"
                  id="select-day-dropdown"
                  aria-label={t("Select day to update")}
                  value={Number(this.state.dayType)}
                  autoMenuWidth
                  disabled={isScoringLocked}
                  onChange={(event) => {
                    this.setState({ dayType: event.target["value"] });
                  }}
                  optionTitleProp="name"
                  optionValueProp="value"
                  options={basicDays}
                  MenuProps={{
                    style: {
                    zIndex: '1500000'
                    },
                  }}
                />
              )}
              </>}
            </div>

            {(this.props.customData && Object.keys(this.props.customData).length > 0 && !this.props.mitChildKr ) && <div className="krBreak" style={{marginBottom:"-10px"}} aria-hidden="true" />}
            {((this.props.addOkrData.groupKRCustomFields|| this.props.groupKRCustomFields) && !this.props.mitChildKr) &&
              <Customokr customData={this.props.customData}
                isRequiredCustomOkrFiled={this.isRequiredCustomOkrFiled}
                onCustomDataChange={(newData) => this.props.onCustomFieldsChange?.(newData)}
                customFiledRequired={true}
                renderError={this.renderError}
                isCustomSave={this.state.isCustomSave}
              />
            }

            {!this.props.mitChildKr &&<>{(!this.props.isChildKr && (this.state.dsMetric != 4 ||  this.props.addOkrData.display_nested_kr)) && <div className="krBreak" aria-hidden="true" />}</>}

            {!this.props.mitChildKr && !this.props.isChildKr && (
              <KrMilestonesSection ref={this.krMilestonesSectionRef} source={krdetailConstants.SOURCE_PERSON} {...this.props} metricState={this.state} metric={this.props.item} onChange={this.handleMilestonesChange} />
            )}
            {!this.props.mitChildKr && <KrRelationshipWrapper {...this.props} metric={this.props.item} saveKr={this.saveKr}/>}
            <AddFinancialTargetsButton objectType="kr" objectId={this.props.item?.id} ownerUserId={this.props.realOwner?.id} />
            {!this.props.mitChildKr &&
               <AddKrTag metric={this.props.item} goalId={this.props.goalDetails.id} taghandler={this.saveTag}
                  nplTags={this.state.nplTags}  selectednlplTags={this.state.selectednlplTags}
                  selectednlplTagsName={this.state.selectednlplTagsName}
                  updateTags={this.updateTags} tagsList={this.state.tagsList} searchText={this.props.krText}
               />
            }
            {
              ((this.props.addOkrData.display_nested_kr &&
              !this.props.isChildKr && !this.props.mitChildKr)&&
              Math.ceil(moment(this.props.goalDetails.target_date).diff(moment(this.props.goalDetails.start_date), "days", true)) >= 360) &&
              <NestedInlineComp
              {...this.props}
              actions = {this.props.actions}
              nested_krs = {this.props.nested_krs}
              updateNestedKrs = {this.props.updateNestedKrs}
              />
            }
            {
              (!this.props.isChildKr && !this.props.mitChildKr) &&
              <KrAlignDependance {...this.props}
                saveDependentArr={this.saveDependentArr}
                saveAlignArr={this.saveAlignArr}
                krAlingArr={this.props.item.kr_aligns}
                krDependenciesArr={this.props.item.kr_dependent}
              />
            }
            {!this.props.mitChildKr && !this.props.isChildKr &&
              <div className="excludeProgressArea">
                <ThemeProvider>
                  <StyledCheckbox
                    id='excludePro'
                    label={`${t('Exclude from objective progress calculation')}`}
                    onChange={this.handleExcludeChange}
                    isChecked={this.state.Exclude ? true : false}
                    isDisabled={isScoringLocked}
                  />
                </ThemeProvider>
              </div>
            }

            {!this.state.applyObjKr && !this.props.mitChildKr && (
              <div className="viewPermissionArea">
                <span>
                  {t('View permissions in addition to')}{" "}
                  {this.props.goalDetails.type == 1 ? t(" team ") : t(" owner ")}
                  <div
                    className="metricTargetHelptext permissionHelpText"
                    onMouseEnter={event => {
                      this.setState({ permissionHelpPopUp: true });
                    }}
                    onMouseLeave={event => {
                      this.setState({ permissionHelpPopUp: false });
                    }}
                  />
                  {this.state.permissionHelpPopUp && (
                    <div className="basic-popup">
                      {t(`You can give your whole organization permission to view your Key Result, or just your team and managers`)}
                    </div>
                  )}
                </span>
              </div>
            )}

            {!this.state.applyObjKr && !this.props.mitChildKr && (
              <PermissionComp
                {...this.props}
                teamPermissionData={this.teamPermissionData}
                bizPermissionData={this.bizPermissionData}
                permissionData={this.permissionData}
                hide={this.state.hide}
              />
            )}
          </div>
        </form>
        {
          this.state.confirmPopup &&
          <DeleteCommonModal
            exitDeleteModal={this.exitDeleteModal}
            deleteItems={this.deleteItems}
            id=""
            title={t(this.state.isAnuualQChange ? 'Save Key Result with new duration' : 'Save Key Result with New Data Type')}
            deleteContentOne=""
            deleteContentSecondParam=""
            deletefirstTitle=""
            deleteContentSecond={t(this.state.isAnuualQChange
              ? 'Are you sure you want to change the duration on this Key Result? This will eliminate all Updates and Confidence Flags on the Key Result.'
              : 'Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data.')}
            buttonText={t(this.state.isAnuualQChange ? 'Change duration' : 'Save')}
          />

        }
        {
          ( this.state.intervalConfirmPopup || this.state.externalSource ) &&
          <RetainUpdateModal
            selectedType={this.state.selectedType}
            changeRadio={this.changeRadio}
            exitDeleteModal={this.exitDeleteModal}
            deleteItems={this.saveItems}
            titleRetain={this.state.titleRetain ? this.state.titleRetain :  t("Save key result with new data type" )}
            contentRetain ={this.state.titleRetain ?  t("Are you sure you want to change the update frequency of this key result?") : t("Are you sure you want to save this key result with the new data type selected?")}
          />
        }
      </div>
    );
  }
}

export default withTranslation()(BasicMetricModal)
